import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SystemService } from './system.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];

  constructor(private router: Router, private ss: SystemService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  getHistory(): string[] {
    return this.history;
  }

  goBack(): void {
    // console.log('History', this.history);
    this.history.pop(); // Remove the current route
    const previousUrl = this.history.pop(); // Get the previous route
    if (previousUrl) {
      this.ss.navigateByUrl(previousUrl, JSON.parse(localStorage.getItem('routeEnvelope')));
    } else {
      this.ss.navigateToDashboard(); // Default fallback route
    }
  }
}
